import { render, staticRenderFns } from "./PlaceInformation.vue?vue&type=template&id=0af37824&"
import script from "./PlaceInformation.vue?vue&type=script&lang=js&"
export * from "./PlaceInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports